import React from "react";
import { COLORS, LANGUAGE_EN_TR } from "rylak-common/src/constants";
import { QUERY_AND_SESSION_KEYS } from "return-portal/src/constants";

export const LOGIN_METHODS = {
    NEW: "NEW",
    OLD: "OLD",
};

export const SESSION_STORE_KEYS = {
    AUTH_HOST: "AUTH_HOST",
    KEY_HOST: "KEY_HOST",
    LOCAL_HOST_ENV: "LOCAL_HOST_ENV",
    KEY_STARTUP_MODAL: "KEY_STARTUP_MODAL",
    GRAPH_TIME_INTERVAL: "GRAPH_TIME_INTERVAL",
    LATEST_USER_ACTIVITY: "LATEST_USER_ACTIVITY",
    LATEST_TOKEN_REFRESH: "LATEST_TOKEN_REFRESH",
    PRE_LOGIN_URL: "PRE_LOGIN_URL",
};

export const QUERY_MAP = {
    APP_DESIGN_FORM_DETAILS: "adfd",
    APP_DESIGN_PREVIEW: "app-design-preview",
    BRAND_QUERY: "b",
    COMPLAINT_STATUS: "c",
    COMPLAINT_TYPE: "ct",
    CONTAINS_COMPLAINT: "cc",
    CONTAINS_EXCHANGE: "ce",
    COUNTRY_CODE: "ccode",
    ECOM: "ec",
    ENTITY_ID: "eid",
    ENTITY_TYPE: "et",
    EXCHANGE_STATUS: "es",
    FILTER_ERROR: "fe",
    FOREIGN_ID: "fid",
    ID: "id",
    IFRAME: "iframe",
    MARKED_AS_DONE: "mad",
    MERCHANT_QUERY: "m",
    MONTH: "month",
    ORDER_ID: "oid",
    ORDER_NAME: "ona",
    ORDER_NUMBER: "onu",
    PRODUCT_CATEGORY_TYPE: "pct",
    PRODUCT_VARIANT: "pv",
    REFUND_ERROR_TYPE: "rfe",
    REFUND_STATUS: "rfs",
    REFUND_TYPE: "rft",
    RESALE_STATUS: "rst",
    RETURN_DELAY_STATUS: "rds",
    RETURN_DELAY_TYPE: "rdt",
    RETURN_ID: "rid",
    RETURN_METHOD: "rm",
    RETURN_STATUS: "rs",
    RISK_LEVEL: "rl",
    SEARCH_STRING: "s",
    SHIPMENT_BOOKING_STATUS: "sbs",
    SHIPMENT_CARRIER: "sc",
    SHIPMENT_DELIVERY_STATUS: "sds",
    SHIPMENT_ID: "sid",
    SHIPMENT_PICKUP: "spu",
    SERVICE_TYPE: "svt",
    SHIPMENT_TYPE: "st",
    SHOW_CANCELLED_ORDERS: "sco",
    STATISTICS_INTERVAL: "sti",
    SUCCESSFUL_SERVICE_CALL: "ssc",
    TABLE_PAGE: "tp",
    TABLE_SIZE: "ts",
    TABLE_SORT: "tsi",
    TABLE_SORT_DIR: "tsd",
    WAREHOUSE_RETURN_ERROR_TYPE: "wret",
    WAREHOUSE_RETURN_SOURCE: "wrs",
    WEBHOOK_NOTIFICATION_STATUS: "wns",
    WEBHOOK_NOTIFICATION_TYPE: "wnt",
    WEIGHED_PERCENTAGE: "wp",
    WITHDRAWAL: "wd",
    WORKER_ERROR_ASSIGNEE: "wea",
    WORKER_ERROR_TYPE: "wet",
    WORKER_STATUS: "ws",
    YEAR: "year",
    SELECTED_ENTITY_TAB: "selected_entity_tab",
};

export const CUSTOMER_NOTIFICATION_TYPE = {
    EMAIL_NOTIFICATION: "EMAIL_NOTIFICATION",
    SMS_NOTIFICATION: "SMS_NOTIFICATION",
};

export const PRODUCT_POLICY = {
    ALWAYS_ACCEPT: {
        key: "ALWAYS_ACCEPT",
        label: "Accept",
    },
    ALWAYS_REJECT: {
        key: "ALWAYS_REJECT",
        label: "Reject",
    },
};

// Mirrors the backend ServiceType enum. RETURN is the standard flow; everything else
// sends the items to a service centre.
export const SERVICE_TYPES = {
    RETURN: "RETURN",
    REPAIR: "REPAIR",
    WASH: "WASH",
};

export const REFUND_TYPES = {
    BASIC: "BASIC",
    GIFT_CARD: "GIFT_CARD",
};

export const REFUND_LINE_TYPES = {
    ITEM_REFUND: "ITEM_REFUND",
    SHIPPING_REFUND: "SHIPPING_REFUND",
    EXCHANGE_COST: "EXCHANGE_COST",
    RETURN_COST: "RETURN_COST",
    RETURN_SHIPMENT_COST: "RETURN_SHIPMENT_COST",
    RETURN_HANDLING_COST: "RETURN_HANDLING_COST",
    FAILED_DELIVERY_COST: "FAILED_DELIVERY_COST",
    GIFT_CARD_ADDITION: "GIFT_CARD_ADDITION",
};

export const REFUND_TRANSACTION_TYPES = {
    CASH: "CASH",
    GIFT_CARD_REFILL: "GIFT_CARD_REFILL",
    GIFT_CARD_CREATION: "GIFT_CARD_CREATION",
};

export const REFUND_MANUAL_TRANSACTION_TYPES = {
    ORDER_DISCOUNT: "ORDER_DISCOUNT",
    REFUND: "REFUND",
    REMOVED_ITEMS: "REMOVED_ITEMS",
};

export const REFUND_MANUAL_TRANSACTION_TYPE_MAP = {
    [REFUND_MANUAL_TRANSACTION_TYPES.REFUND]: {
        label: "Refund",
    },
    [REFUND_MANUAL_TRANSACTION_TYPES.REMOVED_ITEMS]: {
        label: "Removed items",
    },
    [REFUND_MANUAL_TRANSACTION_TYPES.ORDER_DISCOUNT]: {
        label: "Order discount",
    },
};

export const REFUND_TRANSACTION_SOURCE = {
    TURNR: "TURNR",
    OTHER: "OTHER",
    CALCULATED: "CALCULATED",
};

export const REFUND_TRANSACTION_STATUS = {
    SUCCESS: "SUCCESS",
    PENDING: "PENDING",
    FAILED: "FAILED",
    AWAITING_EXTERNAL_REFUND: "AWAITING_EXTERNAL_REFUND",
};

export const ORDER_ITEM_STATUS = {
    NEW: "NEW",
    AWAITING_MANUAL_CHECK: "AWAITING_MANUAL_CHECK",

    AWAITING_RESALE: "AWAITING_RESALE",
    AWAITING_RESALE_SHIPMENT: "AWAITING_RESALE_SHIPMENT",

    AWAITING_RETURN: "AWAITING_RETURN",
    AWAITING_EXTERNAL_RETURN_SHIPMENT: "AWAITING_EXTERNAL_RETURN_SHIPMENT",
    IN_TRANSIT: "IN_TRANSIT",
    ARRIVED_AT_WAREHOUSE: "ARRIVED_AT_WAREHOUSE",
    QUALITY_CHECK: "QUALITY_CHECK",
    RETURNED: "RETURNED",
    LOST_IN_TRANSIT: "LOST_IN_TRANSIT",
    NOT_PICKED_UP: "NOT_PICKED_UP",
    CANCELLED: "CANCELLED",
    NO_RETURN_NEEDED: "NO_RETURN_NEEDED",
};

export const RESALE_STATUS = {
    NEW: "NEW",
    PROCESSING: "PROCESSING",
    QUEUED: "QUEUED",
    PURCHASED: "PURCHASED",
    POSTING: "POSTING",
    POSTED: "POSTED",
    DELISTING: "DELISTING",
    DELISTED: "DELISTED",
    COMPLETED: "COMPLETED",
    CANCELLED: "CANCELLED",
    RESERVED: "RESERVED",
    ERROR: "ERROR",
};

export const INVOICE_STATUS = {
    NEW: "NEW",
    READY_TO_SEND: "READY_TO_SEND",
    SEND_MANUALLY: "SEND_MANUALLY",
    SENT: "SENT",
    PAID: "PAID",
    NO_PAYMENT: "NO_PAYMENT",
};

export const PAYMENT_PLANS = {
    FREE: "FREE",
    PRO: "PRO",
};

export const RETURN_STATUS = {
    UP_FOR_RESALE: "UP_FOR_RESALE",
    IN_TRANSIT: "IN_TRANSIT",
    AWAITING_SHIPMENTS: "AWAITING_SHIPMENTS",
    QUALITY_CHECK: "QUALITY_CHECK",
    AWAITING_MERCHANT_ACTION: "AWAITING_MERCHANT_ACTION",
    COMPLETED: "COMPLETED",
    CANCELLED: "CANCELLED",
    CONFIRMED: "CONFIRMED",
    ARCHIVED: "ARCHIVED",
    AWAITING_MANUAL_SHIPMENT_IMPORT: "AWAITING_MANUAL_SHIPMENT_IMPORT",
};

export const RETURN_DELAY_STATUS = {
    NO_DELAY: "NO_DELAY",
    REMINDER_SENT: "REMINDER_SENT",
    MANUAL_HANDLING: "MANUAL_HANDLING",
    RESOLVED: "RESOLVED",
    ARCHIVED: "ARCHIVED",
};

export const RETURN_DELAY_TYPE = {
    EXCHANGE_NOT_RETURNED: "EXCHANGE_NOT_RETURNED",
    REFUND_NOT_RETURNED: "REFUND_NOT_RETURNED",
    RETURN_NOT_COMPLETED: "RETURN_NOT_COMPLETED",
    PARTIALLY_RETURNED: "PARTIALLY_RETURNED",
    NO_ACTION_NEEDED: "NO_ACTION_NEEDED",
    EXCHANGE_NOT_COMPLETED: "EXCHANGE_NOT_COMPLETED",
};

export const REFUND_STATUS = {
    NEW: "NEW",
    PROCESSING: "PROCESSING",
    COMPLETED: "COMPLETED",
    ERROR: "ERROR",
    DENIED: "DENIED",
    PENDING: "PENDING",
    NO_REFUND: "NO_REFUND",
    REFUNDED_MANUALLY: "REFUNDED_MANUALLY",
};

export const REFUND_ERROR_TYPE = {
    UNKNOWN: "UNKNOWN",
    EXCHANGE_NOT_COMPLETED: "EXCHANGE_NOT_COMPLETED",
    NEGATIVE_AMOUNT: "NEGATIVE_AMOUNT",
    EXCHANGE_COST_PAID_TOO_HIGH: "EXCHANGE_COST_PAID_TOO_HIGH",
    WRONG_REFUND_AMOUNT: "WRONG_REFUND_AMOUNT",
    API_ERROR: "API_ERROR",
    WRONG_CALCULATED_AMOUNT: "WRONG_CALCULATED_AMOUNT",
    MULTI_CURRENCY_REFUND: "MULTI_CURRENCY_REFUND",
    GIFT_CARD_USED: "GIFT_CARD_USED",
    REFUND_TRANSACTION_MISMATCH: "REFUND_TRANSACTION_MISMATCH",
    REFUND_TOTAL_MISMATCH: "REFUND_TOTAL_MISMATCH",
    NON_TURNR_REFUND_EXISTS: "NON_TURNR_REFUND_EXISTS",
    AMOUNT_TOO_SMALL: "AMOUNT_TOO_SMALL",
    INVALID_ORDER_STATE: "INVALID_ORDER_STATE",
    PENDING_REFUND: "PENDING_REFUND",
};

export const RISK_LEVEL = {
    HIGH: "HIGH",
    NORMAL: "NORMAL",
    LOW: "LOW",
};

export const RISK_MAP = {
    HIGH: {
        description: "Characteristics of the customer are similar to high risk customers observed in the past.",
        color: "#ec0000",
        key: "HIGH",
    },
    NORMAL: {
        description: "Characteristics of the customer are similar to normal customer behaviour observed in the past.",
        color: "#00cc00",
        key: "NORMAL",
    },
    LOW: {
        description: "Characteristics of the customer are similar to safe customer behaviour observed in the past.",
        color: "#009900",
        key: "LOW",
    },
};

export const ORDER_ITEM_REFUND_STATUS = {
    NEW: "NEW",
    EXCHANGE_NO_REFUND: "EXCHANGE_NO_REFUND",
    EXCHANGE_REFUNDED_ON_ORIGINAL_ORDER: "EXCHANGE_REFUNDED_ON_ORIGINAL_ORDER",
    REFUNDED: "REFUNDED",
    DENIED_SKIPPING_REFUND: "DENIED_SKIPPING_REFUND",
    NO_REFUND: "NO_REFUND",
    PENDING: "PENDING",
    EXCHANGE_PARTIALLY_REFUNDED: "EXCHANGE_PARTIALLY_REFUNDED",
    EXCHANGE_PARTIAL_REFUND: "EXCHANGE_PARTIAL_REFUND",
    HANDLED_EXTERNALLY: "HANDLED_EXTERNALLY",
    NOTHING_TO_REFUND: "NOTHING_TO_REFUND",
};

export const SHIPMENT_BOOKING_STATUS = {
    NEW: "NEW",
    BOOKING: "BOOKING",
    BOOKED: "BOOKED",
    ERROR: "ERROR",
    UPDATE: "UPDATE",
};

export const SHIPMENT_DELIVERY_STATUS = {
    AWAITING_COLLECT: "AWAITING_COLLECT",
    IN_TRANSIT: "IN_TRANSIT",
    DELIVERED: "DELIVERED",
    CANCELLED: "CANCELLED",
};

export const SHIPMENT_TYPE = {
    C2B: "C2B",
    C2C_BAGS: "C2C_BAGS",
    C2C_FROM: "C2C_FROM",
    C2C_TO: "C2C_TO",
};

export const SHIPMENT_EVENT_TYPE = {
    DELIVERY_COMPLETED: "DELIVERY_COMPLETED",
    PICKUP_COMPLETED: "PICKUP_COMPLETED",
    PICKUP_FAILED: "PICKUP_FAILED",
    DELIVERY_FAILED: "DELIVERY_FAILED",
    CANCELLED: "CANCELLED",
    DROPPED_OFF_AT_SERVICE_POINT: "DROPPED_OFF_AT_SERVICE_POINT",
};

export const SHIPPING_METHOD = {
    PICKUP: "PICKUP",
    RETURN_SLIP: "RETURN_SLIP",
    MANUAL: "MANUAL",
    PRINT_LABEL: "PRINT_LABEL",
    OUTSIDE_TURNR: "OUTSIDE_TURNR",
    PRINT_LABEL_MANUAL_UPLOAD: "PRINT_LABEL_MANUAL_UPLOAD",
    IMPORT_FROM_WMS: "IMPORT_FROM_WMS",
    LOCKER: "LOCKER",
    RETURN_IN_STORE: "RETURN_IN_STORE",
    NO_RETURN_NEEDED: "NO_RETURN_NEEDED",
    REGISTER_WITHDRAWAL: "REGISTER_WITHDRAWAL",
};
export const COMPLAINT_STATUS = {
    PENDING: "PENDING",
    APPROVED: "APPROVED",
    DENIED: "DENIED",
    RETURN_DENIED: "RETURN_DENIED",
};

export const WAREHOUSE_RETURN_STATUS = {
    NEW: "NEW",
    PROCESSING: "PROCESSING",
    PROCESSED: "PROCESSED",
    PLEASE_HANDLE_MANUALLY: "PLEASE_HANDLE_MANUALLY",
    AWAITING_MERCHANT_CHECK: "AWAITING_MERCHANT_CHECK",
    HANDLED_MANUALLY: "HANDLED_MANUALLY",
    ERROR: "ERROR",
    DUPLICATE: "DUPLICATE",
    IGNORED: "IGNORED",
};

export const WAREHOUSE_RETURN_ERROR_TYPE = {
    UNKNOWN: "UNKNOWN",
    API_ERROR: "API_ERROR",
    SKU_NOT_FOUND: "SKU_NOT_FOUND",
    QUANTITY_TOO_HIGH: "QUANTITY_TOO_HIGH",
    ITEM_NOT_REPORTED_THROUGH_TURNR: "ITEM_NOT_REPORTED_THROUGH_TURNR",
    ORDER_WITH_NOT_RETURNABLE_ITEM: "ORDER_WITH_NOT_RETURNABLE_ITEM",
    ORDER_NOT_REPORTED_THROUGH_TURNR: "ORDER_NOT_REPORTED_THROUGH_TURNR",
    FOREIGN_ORDER_NOT_FOUND: "FOREIGN_ORDER_NOT_FOUND",
    FOREIGN_ORDER_MISMATCH: "FOREIGN_ORDER_MISMATCH",
};

export const WAREHOUSE_RETURN_SOURCE = {
    BACKOFFICE: "BACKOFFICE",
    MERCHANT_API: "MERCHANT_API",
    PRIME_PENGUIN_WEBHOOK: "PRIME_PENGUIN_WEBHOOK",
    SHIPHERO_WEBHOOK: "SHIPHERO_WEBHOOK",
    ONGOING_WEBHOOK: "ONGOING_WEBHOOK",
    ORDER_WAREHOUSE_WORKER: "ORDER_WAREHOUSE_WORKER",
    SHIPMONK_WORKER: "SHIPMONK_WORKER",
};

export const WAREHOUSE_ITEM_ACTION = {
    WAREHOUSE_APPROVED: "WAREHOUSE_APPROVED",
    WAREHOUSE_DENIED: "WAREHOUSE_DENIED",
    ITEM_NOT_PICKED_UP: "ITEM_NOT_PICKED_UP",
    AWAITING_MANUAL_CHECK: "AWAITING_MANUAL_CHECK",
};

export const WAREHOUSE_ITEM_STATUS = {
    IGNORE: "IGNORE",
    PROCESSED: "PROCESSED",
    ADDED: "ADDED",
    DUPLICATE: "DUPLICATE",
};

export const EXCHANGE_ORDER_STATUS = {
    NEW: "NEW",
    PROCESSING: "PROCESSING",
    DRAFT_ORDER_CREATED: "DRAFT_ORDER_CREATED",
    AWAITING_MANUAL_CHECK: "AWAITING_MANUAL_CHECK",
    ORDERED: "ORDERED",
    AWAITING_RETURN: "AWAITING_RETURN",
    AWAITING_SHIPMENT: "AWAITING_SHIPMENT",
    REQUIRES_MANUAL_APPROVAL: "REQUIRES_MANUAL_APPROVAL",
    EXCHANGE_DENIED: "EXCHANGE_DENIED",
    ERROR: "ERROR",
    CANCELLED: "CANCELLED",
    HANDLED_EXTERNALLY: "HANDLED_EXTERNALLY",
    AWAITING_EXTERNAL_HANDLING: "AWAITING_EXTERNAL_HANDLING",
};

export const EXCHANGE_COST_TYPE = {
    FIXED: "FIXED",
    FREE: "FREE",
    CALCULATED_SHIPPING: "CALCULATED_SHIPPING",
};

export const EMAIL_NOTIFICATION_TYPE = {
    COMPLETE_EXCHANGE: "COMPLETE_EXCHANGE",
    COMPLAINT_REPORTED: "COMPLAINT_REPORTED",
    COMPLAINT_DENIED: "COMPLAINT_DENIED",
    COMPLAINT_APPROVED: "COMPLAINT_APPROVED",
    RETURN_REGISTERED: "RETURN_REGISTERED",
    RETURN_BACK_TO_STORE: "RETURN_BACK_TO_STORE",
    RETURN_SOLD: "RETURN_SOLD",
    RETURN_SLIP_DELIVERY: "RETURN_SLIP_DELIVERY",
    ABROAD_MANUAL_RETURN: "ABROAD_MANUAL_RETURN",
    PRODUCT_IN_STOCK: "PRODUCT_IN_STOCK",
    GIFT_CARD_CREATED: "GIFT_CARD_CREATED",
    PRINT_LABEL_DELIVERY: "PRINT_LABEL_DELIVERY",
    RETURN_DELIVERED_TO_WAREHOUSE: "RETURN_DELIVERED_TO_WAREHOUSE",
    RETURN_COMPLETED: "RETURN_COMPLETED",
    RETURN_DENIED: "RETURN_DENIED",
    PRINT_LABEL_BOOKING_FAILED: "PRINT_LABEL_BOOKING_FAILED",
    RETURN_NOT_RECEIVED: "RETURN_NOT_RECEIVED",
};

export const SMS_NOTIFICATION_TYPE = {
    PICKUP_REMINDER: "PICKUP_REMINDER",
    BAGS_DELIVERED: "BAGS_DELIVERED",
};

export const MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

/**
 * These decide what entities you have access to (but also sometimes functionality)
 */
export const USER_TYPES = {
    TURNR: "TURNR",
    SHOP: "SHOP",
    SHOP_GROUP: "SHOP_GROUP",
    SHIPMENT_CARRIER: "SHIPMENT_CARRIER",
};

/**
 * These decide what functionality/pages you have access to
 */
// export const USER_ROLES = {
//     ADMIN: "ADMIN",
//     SUPPORT: "SUPPORT",
//     SHIPMENT: "SHIPMENT", // To be removed
//     WAREHOUSE: "WAREHOUSE", // To be removed
//     SUPER_ADMIN: "SUPER_ADMIN",
//     OBSERVER: "OBSERVER",
// };
export const USER_ROLES = {
    SUPER_ADMIN: {
        id: "SUPER_ADMIN",
        name: "Super Admin",
        color: COLORS.C2C,
    },
    ADMIN: {
        id: "ADMIN",
        name: "Admin",
        color: COLORS.SUCCESS,
    },
    OBSERVER: {
        id: "OBSERVER",
        name: "Observer",
        color: COLORS.GREY,
    },
    SUPPORT: {
        id: "SUPPORT",
        name: "Support",
        color: COLORS.ACTION,
    },
    SHIPMENT: {
        id: "SHIPMENT",
        name: "Shipment",
        color: COLORS.ORANGE.main,
    }, // To be removed
    WAREHOUSE: {
        id: "WAREHOUSE",
        name: "Warehouse",
        color: COLORS.ORANGE.main,
    }, // To be removed
};

export const USER_LOGIN_TYPES = {
    SHOPIFY: "SHOPIFY",
    OBSERVER: "OBSERVER",
};

export const PRODUCT_POLICY_TYPES = {
    PRODUCT: "PRODUCT",
    PRODUCT_CATEGORY: "PRODUCT_CATEGORY",
};

export const SHOP_TYPES = {
    BRINK: "BRINK",
    BRINK_RETAIL: "BRINK_RETAIL",
    CENTRA: "CENTRA",
    CUSTOM: "CUSTOM",
    JETSHOP: "JETSHOP",
    SHOPIFY: "SHOPIFY",
    WOOCOMMERCE: "WOOCOMMERCE",
    RAPUNZEL: "RAPUNZEL",
    MAGENTO: "MAGENTO",
    DEMO: "DEMO",
    NAKD: "NAKD",
    SALESFORCE_CORE: "SALESFORCE_CORE",
    INGRID_TOS: "INGRID_TOS",
};

// export const SHOP_LINK_TYPES = {
//     ORDER: "ORDER",
//     PRODUCT: "PRODUCT",
//     PRODUCT_VARIANT: "PRODUCT_VARIANT",
//     GIFT_CARD: "GIFT_CARD",
// };

export const ADMIN_PAGE_TABS = {
    SHOP: "SHOP",
    SHOP_GROUP: "SHOP_GROUP",
    USERS: "USERS",
};

export const ROUTES = {
    MAIN: "/",

    // Product
    PRODUCT: "/products/[id]",
    PRODUCTS: "/products",
    PRODUCT_CATEGORIES: "/products/categories",
    PRODUCT_CATEGORY: "/products/categories/[id]",
    PRODUCT_POLICIES: "/products/policies",

    // Integrations
    INTEGRATIONS_ECOM: "/integrations/ecom",
    INTEGRATIONS_SHIPMENT: "/integrations/shipment",
    INTEGRATIONS_WAREHOUSE: "/integrations/warehouse",
    INTEGRATIONS_WEBHOOK_NOTIFICATIONS: "/integrations/webhook-notifications",
    INTEGRATIONS_WEBHOOK_NOTIFICATIONS_OUTGOING: "/integrations/webhook-notifications-outgoing",
    INTEGRATIONS_WEBHOOK_OUTGOING_SUBSCRIPTIONS: "/integrations/webhook-outgoing-subscriptions",
    SETTINGS_API_KEYS: "/settings/api-keys",

    // Returns
    RETURN: "/returns/[id]",
    RETURNS: "/returns",
    RETURNS_ACTIVE: "/returns/active",
    RETURNS_ACTIONS: "/returns/actions",
    RETURNS_COMPLAINTS: "/returns/complaints",
    RETURNS_DELAYS: `/returns/delays?${QUERY_MAP.RETURN_DELAY_STATUS}=${RETURN_DELAY_STATUS.MANUAL_HANDLING}`,
    RETURNS_EXCHANGES: "/returns/exchanges",
    RETURNS_EXCHANGE_ISSUES: `/returns/exchanges?${QUERY_MAP.FILTER_ERROR}=true`,
    RETURNS_ISSUES: `/returns/issues?${QUERY_MAP.FILTER_ERROR}=true`,
    RETURNS_REFUNDS: "/refunds",
    RETURNS_REFUND_ISSUES: `/refunds?${QUERY_MAP.FILTER_ERROR}=true`,
    RETURNS_RESALES: "/returns/resales",
    RETURNS_SHIPMENT: "/shipments/[id]",
    RETURNS_SHIPMENTS: "/shipments",
    RETURNS_SHIPMENT_ISSUES: `/shipments?${QUERY_MAP.FILTER_ERROR}=true`,
    RETURNS_UPLOAD_LABEL: `/returns/upload-label?${QUERY_MAP.RETURN_STATUS}=${RETURN_STATUS.AWAITING_MANUAL_SHIPMENT_IMPORT}`,

    // Settings
    SETTINGS_ADMIN_SETTINGS: "/settings/admin",
    SETTINGS_APP_DESIGN: "/settings/app-design",
    SETTINGS_EMAIL_TEMPLATES: "/settings/email",
    SETTINGS_PRICE_SETUPS: "/settings/price-setups",
    SETTINGS_RETURN_REASONS: "/settings/return-reasons",
    SETTINGS_SHOP: "/settings/shop",
    SETTINGS_TEXT_OVERRIDES: "/settings/text-overrides",
    SETTINGS_USERS: `/settings/admin?${QUERY_AND_SESSION_KEYS.PAGE_TAB}=${ADMIN_PAGE_TABS.USERS_TAB}`,
    SETTINGS_USER_SETTINGS: "/settings/user",

    // Warehouse
    WAREHOUSE_REQUIRE_ACTION: "/warehouse-reports/require-action",
    WAREHOUSE_ISSUES: `/warehouse-reports/issues?${QUERY_MAP.FILTER_ERROR}=true`,
    WAREHOUSE_REPORTS: "/warehouse-reports",
    WAREHOUSE_QUALITY_CHECK: "/quality-check",
    // Others
    BAG_SHIPMENTS: "/bag-shipments",
    BILLING: "/billing",
    CUSTOMERS: "/customers",
    CUSTOMER: "/customers/[id]",
    ENTITY_EVENTS: "/entity-events",
    ENTITY_EXPLORER: "/entity-explorer",
    ERRORS: "/errors",
    IMAGE_UPLOAD: "/image-upload",
    SHIPMENT_LABEL: "/shipment-label",
};

export const ROUTES_VALUES_WITHOUT_QUERY = Object.values(ROUTES).map((route) => route.split("?")[0]);

export const RETURN_REASONS = {
    EXCHANGE: "EXCHANGE",
    COMPLAINT: "COMPLAINT",
};

export const LANGUAGE_EN = "EN";

export const LANGUAGE_CODE_MAPPER = {
    BEN: {
        countryCode: "BD",
        name: "Bengali",
    },
    BG: {
        countryCode: "BG",
        name: "Bulgarian",
    },
    ZH: {
        countryCode: "CN",
        name: "Chinese",
    },
    HR: {
        countryCode: "HR",
        name: "Croatian",
    },
    CS: {
        countryCode: "CZ",
        name: "Czech",
    },
    DA: {
        countryCode: "DK",
        name: "Danish",
    },
    NL: {
        countryCode: "NL",
        name: "Dutch",
    },
    NL_BE: {
        countryCode: "BE",
        name: "Dutch (Belgium)",
    },
    [LANGUAGE_EN]: {
        countryCode: "GB",
        name: "English",
    },
    [LANGUAGE_EN_TR]: {
        countryCode: "EN_TR",
        name: "English auto-translation",
    },
    ET: {
        countryCode: "EE",
        name: "Estonian",
    },
    FI: {
        countryCode: "FI",
        name: "Finnish",
    },
    FR: {
        countryCode: "FR",
        name: "French",
    },
    FR_BE: {
        countryCode: "BE",
        name: "French (Belgium)",
    },
    DE: {
        countryCode: "DE",
        name: "German",
    },
    DE_AT: {
        countryCode: "AT",
        name: "German (Austria)",
    },
    EL: {
        countryCode: "GR",
        name: "Greek",
    },
    HI: {
        countryCode: "IN",
        name: "Hindi",
    },
    HU: {
        countryCode: "HU",
        name: "Hungarian",
    },
    ID: {
        countryCode: "ID",
        name: "Indonesian",
    },
    GA: {
        countryCode: "IE",
        name: "Irish",
    },
    IT: {
        countryCode: "IT",
        name: "Italian",
    },
    JA: {
        countryCode: "JP",
        name: "Japanese",
    },
    KOR: {
        countryCode: "KR",
        name: "Korean",
    },
    LV: {
        countryCode: "LV",
        name: "Latvian",
    },
    LT: {
        countryCode: "LT",
        name: "Lithuanian",
    },
    MT: {
        countryCode: "MT",
        name: "Maltese",
    },
    NO: {
        countryCode: "NO",
        name: "Norwegian",
    },
    PL: {
        countryCode: "PL",
        name: "Polish",
    },
    PT: {
        countryCode: "PT",
        name: "Portuguese",
    },
    RO: {
        countryCode: "RO",
        name: "Romanian",
    },
    SK: {
        countryCode: "SK",
        name: "Slovak",
    },
    SL: {
        countryCode: "SI",
        name: "Slovenian",
    },
    ES: {
        countryCode: "ES",
        name: "Spanish",
    },
    SW: {
        countryCode: "KE",
        name: "Swahili",
    },
    SV: {
        countryCode: "SE",
        name: "Swedish",
    },
    VIE: {
        countryCode: "VN",
        name: "Vietnamese",
    },
};

export const CURRENCIES = {
    USD: "USD",
};

export const PACKAGE_TYPES = {
    C2C: "C2C",
    RETURN: "RETURN",
};

export const SHIPMENT_CUSTOMS_TYPES = {
    NO_CUSTOMS: "NO_CUSTOMS",
    PLT: "PLT",
    CUSTOMS: "CUSTOMS",
};

export const WMS_TYPES = {
    ONGOING: {
        key: "ONGOING",
        name: "Ongoing",
        icon: "/icons/wms/ongoing.svg",
        iconWidth: 52,
        iconHeight: 15,
    },
    PRIME_PENGUIN: {
        key: "PRIME_PENGUIN",
        name: "Prime Penguin",
        icon: "/icons/wms/prime_penguin.png",
        iconWidth: 66,
        iconHeight: 15,
    },
    SHIP_HERO: {
        key: "SHIP_HERO",
        name: "Ship Hero",
        icon: "/icons/wms/ship_hero.svg",
        iconWidth: 52,
        iconHeight: 15,
    },
    SHIP_MONK: {
        key: "SHIP_MONK",
        name: "Ship Monk",
        icon: "/icons/wms/ship_monk.png",
        iconWidth: 60,
        iconHeight: 15,
    },
    TURNR_WMS: {
        key: "TURNR_WMS",
        name: "Ingrid Quality Check",
        icon: "/icons/wms/turnr_wms.png",
        iconWidth: 41,
        iconHeight: 15,
    },
    BONVER: {
        key: "BONVER",
        name: "Bonver",
        icon: "/icons/wms/bonver.webp",
        iconWidth: 64,
        iconHeight: 15,
    },
    DREAM_LOGISTICS: {
        key: "DREAM_LOGISTICS",
        name: "Shelfless",
        icon: "/icons/wms/shelfless.png",
        iconWidth: 52,
        iconHeight: 15,
    },
    DSV: {
        key: "DSV",
        name: "DSV",
        icon: "/icons/wms/dsv.svg",
        iconWidth: 52,
        iconHeight: 15,
    },
};

export const ENTITY_TYPE = {
    API_KEY: "API_KEY",
    COMPLAINT_REASON: "COMPLAINT_REASON",
    CUSTOMER: "CUSTOMER",
    EMAIL_NOTIFICATION: "EMAIL_NOTIFICATION",
    ENTITY_EVENT: "ENTITY_EVENT",
    EXCHANGE_ORDER: "EXCHANGE_ORDER",
    EXTERNAL_NOTIFICATION: "EXTERNAL_NOTIFICATION",
    INVOICE: "INVOICE",
    ORDER: "ORDER",
    ORDER_COMMENT: "ORDER_COMMENT",
    ORDER_ITEM: "ORDER_ITEM",
    ORDER_ITEM_COMPLAINT: "ORDER_ITEM_COMPLAINT",
    ORDER_ITEM_RETURN_REASON: "ORDER_ITEM_RETURN_REASON",
    ORDER_LINE_ITEM: "ORDER_LINE_ITEM",
    COMPLAINT_IMAGE: "COMPLAINT_IMAGE",
    PRICE_LIST: "PRICE_LIST",
    PRODUCT: "PRODUCT",
    PRODUCT_CATEGORY: "PRODUCT_CATEGORY",
    PRODUCT_POLICY: "PRODUCT_POLICY",
    PRODUCT_VARIANT: "PRODUCT_VARIANT",
    REFUND: "REFUND",
    REFUND_TRANSACTION: "REFUND_TRANSACTION",
    RESALE: "RESALE",
    RETURN: "RETURN",
    RETURN_REASON: "RETURN_REASON",
    RETURN_REASON_CONFIG: "RETURN_REASON_CONFIG",
    SHIPMENT: "SHIPMENT",
    SHIPMENT_INTEGRATION: "SHIPMENT_INTEGRATION",
    SHIPMENT_EVENT: "SHIPMENT_EVENT",
    SHOP: "SHOP",
    SHOP_ADDRESS: "SHOP_ADDRESS",
    SHOP_GROUP: "SHOP_GROUP",
    SHOP_STATISTICS: "SHOP_STATISTICS",
    SMS_NOTIFICATION: "SMS_NOTIFICATION",
    USER: "USER",
    WAREHOUSE_RETURN: "WAREHOUSE_RETURN",
    WAREHOUSE_RETURN_ITEM: "WAREHOUSE_RETURN_ITEM",
    WEBHOOK_NOTIFICATION: "WEBHOOK_NOTIFICATION",
    WEBHOOK_SUBSCRIPTION: "WEBHOOK_SUBSCRIPTION",
    WMS_INTEGRATION: "WMS_INTEGRATION",
};

export const ENTITY_SCOPE = {
    FULL: "FULL",
    SHALLOW: "SHALLOW",
};

export const ENTITY_ACTION_PAGE = {
    QUALITY_CHECK: "QUALITY_CHECK",
    PRODUCT_POLICIES: "PRODUCT_POLICIES",
};

export const ENTITY_ACTION_TYPE = {
    EDIT: "EDIT",
    RETURN_HANDLE_COMPLAINT: "RETURN_HANDLE_COMPLAINT",
    HANDLE_WAREHOUSE_COMPLAINT: "HANDLE_WAREHOUSE_COMPLAINT",
    RETURN_EDIT_REFUND: "RETURN_EDIT_REFUND",
    SHOP_EDIT_ROLE_PERMISSIONS: "SHOP_EDIT_ROLE_PERMISSIONS",
    UPLOAD_SHIPMENT_LABEL: "UPLOAD_SHIPMENT_LABEL",
    RETURN_CREATE_COMMENT: "RETURN_CREATE_COMMENT",
    RETURN_CREATE: "RETURN_CREATE",
};

export const WORKER_STATUS = {
    READY: "READY",
    PROCESSING: "PROCESSING",
    ERROR: "ERROR",
};

export const WORKER_ERROR_ASSIGNEE = {
    TURNR_DEVELOPERS: "TURNR_DEVELOPERS",
    TURNR_SUPPORT: "TURNR_SUPPORT",
    SHOP_SUPPORT: "SHOP_SUPPORT",
};

export const WORKER_ERROR_TYPE = {
    UNMATCHED_WAREHOUSE_ITEMS: "UNMATCHED_WAREHOUSE_ITEMS",
};

export const WORKER_ERROR_ACTION_TYPE = {
    DELETE: "DELETE",
    EDIT: "EDIT",
    RETRY: "RETRY",
};

export const STATISTIC_AGGREGATES = {
    TOTAL: "TOTAL",
    LAST_3_MONTHS: "LAST_3_MONTHS",
    LAST_90_DAYS: "LAST_90_DAYS",
    LAST_1_YEAR: "LAST_1_YEAR",
};

export const HIGHLIGHT_TYPES = {
    RETURNS: "RETURNS",
    COMPLAINTS: "COMPLAINTS",
    EXCHANGES: "EXCHANGES",
    RESALES: "RESALES",
    GIFTCARDS: "GIFTCARDS",
};

export const EXCHANGE_POLICIES = {
    IMMEDIATE_EXCHANGE: "IMMEDIATE_EXCHANGE",
    EXCHANGE_ON_RETURN: "EXCHANGE_ON_RETURN",
    EXCHANGE_ON_SHIPMENT: "EXCHANGE_ON_SHIPMENT",
    MANUAL_APPROVAL: "MANUAL_APPROVAL",
    EXCHANGE_ON_ARRIVED_AT_WAREHOUSE: "EXCHANGE_ON_ARRIVED_AT_WAREHOUSE",
};

//TODO should not be here
export const TOOLTIP_TEXTS = {
    PRICE_SETUP_PRIORITY: "If you have multiple Price Setups targeting the same country and/or location. The Price Setup with the highest priority (lowest number) will be used",
    PRICE_SETUP_RETURN_HANDLING_COST: (
        <span>
            The cost for making a return.
            <br />
            <br />
            The shipment cost will be added to the total customer cost.
            <br />
            <br />
            Does not multiply with the amount of items the user returns.
        </span>
    ),
    PRICE_SETUP_EXCHANGE_COST: (
        <span>
            The customer cost for making an exchange.
            <br />
            <br />
            No shipment cost will be added when a customer makes an exchange.
            <br />
            <br />
            Does not multiply with the amount of items the user exchanges.
        </span>
    ),
    PRICE_SETUP_FAILED_DELIVERY_COST: (
        <span>
            Extra cost added for orders that were never picked up by the customer.
            <br />
            <br />
            Is added in addition to other costs.
        </span>
    ),
};

export const STATISTICS_MAP = {
    LAST_3_MONTHS: { key: "LAST_3_MONTHS", name: "Last 3 months" },
    TOTAL: { key: "TOTAL", name: "All Time" },
    LAST_90_DAYS: { key: "LAST_90_DAYS", name: "Last 90 days" },
    LAST_1_YEAR: { key: "LAST_1_YEAR", name: "Last year" },
};

export const BRAND_STYLE_TYPES = {
    SHARP: "SHARP",
    SLIGHTLY_ROUNDED: "SLIGHTLY_ROUNDED",
    ROUNDED: "ROUNDED",
    VERY_ROUNDED: "VERY_ROUNDED",
    FULLY_ROUNDED: "FULLY_ROUNDED",
};

export const EMAIL_TEMPLATES = {
    // COMPLAINT
    COMPLAINT_REPORTED: "COMPLAINT_REPORTED",
    COMPLAINT_APPROVED: "COMPLAINT_APPROVED",
    COMPLAINT_DENIED: "COMPLAINT_DENIED",
    RETURN_DENIED: "RETURN_DENIED",

    //C2C
    RETURN_REGISTERED: "RETURN_REGISTERED",
    RETURN_SOLD: "RETURN_SOLD",

    //Shipment instructions

    BOOKING_SHIPMENT: "BOOKING_SHIPMENT",
    PICKUP: "PICKUP",
    CUSTOMER_PRINTS_LABEL: "CUSTOMER_PRINTS_LABEL",
    RETURN_SLIP: "RETURN_SLIP",
    CUSTOMER_BOOKS_OWN_SHIPMENT: "CUSTOMER_BOOKS_OWN_SHIPMENT",

    //Exchange
    EXCHANGE_PAYMENT: "EXCHANGE_PAYMENT",
    EXCHANGE_REMINDER: "EXCHANGE_REMINDER",

    //Shipment updates
    RETURN_ARRIVED_AT_WAREHOUSE: "RETURN_ARRIVED_AT_WAREHOUSE",

    //Completed
    COMPLETED_BASIC_REFUND: "COMPLETED_BASIC_REFUND",
    COMPLETED_GIFT_CARD: "COMPLETED_GIFT_CARD",
};

export const WEBHOOK_NOTIFICATION_STATUS = {
    NEW: "NEW",
    SENT: "SENT",
    FAILED: "FAILED",
};

export const ENTITY_EVENT_TYPES = {
    EMAIL_NOTIFICATION: "EMAIL_NOTIFICATION",
    SMS_NOTIFICATION: "SMS_NOTIFICATION",
    RETURN_CREATE_COMMENT: "RETURN_CREATE_COMMENT",
};

export const EVENT_TYPE = {
    CREATED: "CREATED",
};
